<template>
  <div class="supply">
    <div v-if="facility=='app'" class="app">
      <App :barList='barlist' />
    </div>
    <div v-else>
      <Pc :barList='barlist'/>
    </div>
  </div>
</template>

<script>
import App from "./app/index";
import Pc from "./pc/index";

export default {
  components:{
    App,
    Pc
  },
  data(){
    return{
      facility:"",
      barlist:[
        {
        sortid:0,
        name_cn:"全部",
        name_en:"全部",
        name:"全部",
        url:"/quanbu",
        flag:false
        },{
        sortid:1,
        name_cn:"石油石化",
        name_en:"石油石化",
        name:"石油石化",
        url:"/shiyoushihua",
        flag:false
        },{
          sortid:2,
        name_cn:"页岩气",
        name_en:"页岩气",
        name:"页岩气",
        url:"/yeyanqi",
        flag:false
        },{
        sortid:4,
        name_cn:"管道与储运",
        name_en:"管道与储运",
        name:"管道与储运",
        url:"/guandao",
        flag:false
        },{
        sortid:5,
        name_cn:"海工装备",
        name_en:"海工装备",
        name:"海工装备",
        url:"/haigong",
        flag:false
        },{
        sortid:3,
        name_cn:"海洋石油天然气",
        name_en:"海洋石油天然气",
        name:"海洋石油天然气",
        url:"/haiyang",
        flag:false
        },{
        sortid:6,
        name_cn:"安全防护",
        name_en:"安全防护",
        name:"安全防护",
        url:"/anquan",
        flag:false
        },{
        sortid:7,
        name_cn:"天然气",
        name_en:"天然气",
        name:"天然气",
        url:"/tianranqi",
        flag:false
        },{
        sortid:8,
        name_cn:"防爆仪器仪表",
        name_en:"防爆仪器仪表",
        name:"防爆仪器仪表",
        url:"/fangbao",
        flag:false
        },{
        sortid:9,
        name_cn:"智能油田",
        name_en:"智能油田",
        name:"智能油田",
        url:"/zhineng",
        flag:false
        },{
          sortid:10,
        name_cn:"油田土壤修复",
        name_en:"油田土壤修复",
        name:"油田土壤修复",
        url:"/youtian",
        flag:false
        },{
          sortid:11,
        name_cn:"其他",
        name_en:"其他",
        name:"其他",
        url:"/qita",
        flag:false
        },
      ],
      base64List:[]
  }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style>

</style>